var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderenterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 631,
    height: 443,
    viewBox: "0 0 631 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236 45.0103H245.92C268.253 45.0103 286.609 63.2901 286.609 85.7V353.702C286.609 376.035 268.329 394.392 245.92 394.392H94.6331C72.2996 394.392 53.9434 376.112 53.9434 353.702V85.7C53.9434 63.3665 72.2232 45.0103 94.6331 45.0103H198",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M236 45.0103H245.92C268.253 45.0103 286.609 63.2901 286.609 85.7V353.702C286.609 376.035 268.329 394.392 245.92 394.392H94.6331C72.2996 394.392 53.9434 376.112 53.9434 353.702V85.7C53.9434 63.3665 72.2232 45.0103 94.6331 45.0103H198",
    stroke: "#324A6D",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.647 197.672C166.834 197.672 161.098 199.431 156.279 202.643C151.461 205.856 147.637 210.521 145.419 215.875C143.201 221.305 142.589 227.195 143.736 232.931C144.883 238.667 147.713 243.945 151.843 248.075C155.973 252.205 161.251 255.035 166.987 256.182C172.724 257.33 178.613 256.718 184.043 254.5C189.474 252.282 194.063 248.457 197.275 243.639C200.487 238.82 202.247 233.084 202.247 227.271C202.247 219.47 199.111 211.898 193.604 206.391C188.097 200.884 180.525 197.748 172.724 197.748L172.647 197.672ZM113.601 148.492H143.124V175.797C152.073 170.596 162.322 167.919 172.647 167.996C184.349 167.996 195.745 171.438 205.459 177.939C215.173 184.44 222.744 193.618 227.181 204.479C231.617 215.263 232.84 227.118 230.546 238.591C228.251 250.064 222.668 260.542 214.408 268.802C206.147 277.063 195.592 282.723 184.196 284.941C172.724 287.235 160.868 286.011 150.084 281.575C139.3 277.139 130.045 269.567 123.621 259.854C117.119 250.14 113.678 238.744 113.678 227.042V148.492H113.601Z",
    fill: "#F7A824"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("line", {
    y1: 39.5,
    x2: 631,
    y2: 39.5,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 401.5,
    x2: 631,
    y2: 401.5,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.5,
    y1: 2.15227e-8,
    x2: 292.5,
    y2: 443,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.5,
    y1: 2.15227e-8,
    x2: 47.5,
    y2: 443,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.5,
    y1: 2.15227e-8,
    x2: 113.5,
    y2: 443,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.5,
    y1: 2.15227e-8,
    x2: 143.5,
    y2: 443,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.5,
    y1: 2.15227e-8,
    x2: 202.5,
    y2: 443,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 2.15227e-8,
    x2: 231.5,
    y2: 443,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 631,
    y1: 147.5,
    x2: 29,
    y2: 147.5,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 631,
    y1: 167.5,
    x2: 29,
    y2: 167.5,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 631,
    y1: 197.5,
    x2: 29,
    y2: 197.5,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 631,
    y1: 255.5,
    x2: 29,
    y2: 255.5,
    stroke: "#324A6D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 631,
    y1: 285.5,
    x2: 29,
    y2: 285.5,
    stroke: "#324A6D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderenterprise);
export default __webpack_public_path__ + "static/media/header.enterprise.f29d40e7ca763fb16463ede1516878cf.svg";
export { ForwardRef as ReactComponent };